import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { ApiConnectionListInitialState, ApiConnectionListLoad } from './api-connection-list.actions';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { ApiConnectionListService } from './api-connection-list.service';
import { ApiConnectionBrief } from '../models';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type ApiConnectionListStateModel = ListServerPaginationStateModel<ApiConnectionBrief>;

const initialState: ApiConnectionListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<ApiConnectionListStateModel>({
  name: 'apiConnectionList',
  defaults: initialState,
})
@Injectable()
export class ApiConnectionListState {
  constructor(
    public apiConnectionListService: ApiConnectionListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: ApiConnectionListStateModel): ApiConnectionListStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ApiConnectionListStateModel): boolean {
    return state.loaded;
  }

  @Action(ApiConnectionListLoad)
  getApiConnections(
    ctx: StateContext<ApiConnectionListStateModel>,
    { payload }: ApiConnectionListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.apiConnectionListService.getApiConnectionList(payload).pipe(
      take(1),
      map((apiConnectionList: ApiConnectionBrief[]) => {
        ctx.patchState({ ...apiConnectionList, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ApiConnectionListInitialState)
  setInitialState(ctx: StateContext<ApiConnectionListStateModel>): void {
    ctx.setState(initialState);
  }
}
